import React from "react";

function Header() {
    return (
        <div className="sticky top-0 z-10 rounded bg-gray-50 backdrop-blur bg-opacity-30 border-gray-200 border-b flex space-x-3 px-2 py-4 justify-end">
            {/* <h2 className="items-start">Header</h2> */}
            <div className="">
                <div className="text-2xl">Home</div>
                <div className="text-2xl"></div>
            </div>
        </div>
    );
}
export default Header;
